(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slidehsow"] && !Shopify.designMode) return;
  try {
    
// Slideshow behaviour. Lives in a Liquid javascript block, not an inline
// <script>, for two reasons:
//
//  1. Size — a section emits its inline <script> once per instance, and the
//     homepage has two slideshows, so this was shipped twice per page load.
//     Shopify emits a section's javascript block once per section TYPE, into
//     the already-deferred compiled_assets/scripts.js bundle.
//
//  2. Correctness — both routines below select every slideshow on the page
//     via [id^="atomic-slideshow-"], and initIndividualSlideshow() has no
//     re-entry guard: each call attaches a fresh set of touch/mouse handlers
//     and opens its own setInterval in a new closure. Running the script
//     twice therefore gave every slideshow TWO competing auto-rotate timers.
//     Emitting it once fixes that.
document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll('[id^="atomic-slideshow-"]');

  containers.forEach((container) => {
    initIndividualSlideshow(container);
  });

  // On Shopify section load (dynamic reload)
  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('[id^="atomic-slideshow-"]');
    if (container) {
      initIndividualSlideshow(container);
    }
  });

  function initIndividualSlideshow(container) {
    let startX = 0;
let isDragging = false;

container.addEventListener("touchstart", (e) => {
  startX = e.touches[0].clientX;
  isDragging = true;
});

container.addEventListener("touchmove", (e) => {
  if (!isDragging) return;
  const moveX = e.touches[0].clientX;
  const diff = startX - moveX;

  if (Math.abs(diff) > 50) {
    if (diff > 0) {
      // Swipe left
      currentIndex = (currentIndex + 1) % slides.length;
    } else {
      // Swipe right
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    }
    showSlide(currentIndex);
    isDragging = false;
  }
});

container.addEventListener("touchend", () => {
  isDragging = false;
});

let startMouseX = 0;

container.addEventListener("mousedown", (e) => {
  startMouseX = e.clientX;
  isDragging = true;
});

container.addEventListener("mousemove", (e) => {
  if (!isDragging) return;
  const moveX = e.clientX;
  const diff = startMouseX - moveX;

  if (Math.abs(diff) > 50) {
    if (diff > 0) {
      // Drag left
      currentIndex = (currentIndex + 1) % slides.length;
    } else {
      // Drag right
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    }
    showSlide(currentIndex);
    isDragging = false;
  }
});

container.addEventListener("mouseup", () => {
  isDragging = false;
});

container.addEventListener("mouseleave", () => {
  isDragging = false;
});

    let delayAttr = container.getAttribute("data-delay");
    let delay = Number(delayAttr) > 0 ? Number(delayAttr) * 1000 : 5000;

    let autoRotate = container.dataset.autoRotate === "true";
    let pauseAutoRotate = container.dataset.pauseAutoRotate === "true";

    let slides,
      bullets,
      currentIndex = 0,
      autoRotateInterval = null,
      selectedBlockId = null,
      videoPlaying = false;

    function updateAttributes() {
      autoRotate = container.dataset.autoRotate === "true";
      delayAttr = container.getAttribute("data-delay");
      delay = Number(delayAttr) > 0 ? Number(delayAttr) * 1000 : 5000;
      pauseAutoRotate = container.dataset.pauseAutoRotate === "true";
    }

    function initSlideshow() {
      updateAttributes();
      slides = container.querySelectorAll(".CSSgal .slider .slide");
      bullets = container.querySelectorAll(".CSSgal .bullets a");

      if (!slides.length) return;

      if (Shopify?.designMode && selectedBlockId) {
        const foundIndex = Array.from(slides).findIndex(
          (slide) => slide.dataset.blockId === selectedBlockId
        );
        if (foundIndex !== -1) currentIndex = foundIndex;
      }

      showSlide(0);

      clearInterval(autoRotateInterval);
      if (autoRotate && slides.length > 1) {
        autoRotateInterval = setInterval(loop, delay);
      }

      bullets.forEach((bullet, index) => {
        bullet.removeEventListener("click", handleBulletClick);
        bullet.addEventListener("click", (e) => handleBulletClick(e, index));
      });
    }

    function showSlide(index) {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('active', isActive);

        const videos = slide.querySelectorAll('video');

        if (videos.length > 0) {
          videos.forEach(video => {
            video.pause();
            video.currentTime = 0;
            video.loop = false;

            if (isActive) {
              if (!autoRotate) {
                video.loop = true;
              }

              video.play().catch(err => {
                console.error("Video play error:", err);
              });

              if (pauseAutoRotate && autoRotate) {
                clearInterval(autoRotateInterval);
                autoRotateInterval = null;
                videoPlaying = true;

                video.onended = () => {
                  videoPlaying = false;
                  if (autoRotate && slides.length > 1 && !autoRotateInterval) {
                    autoRotateInterval = setInterval(loop, delay);
                  }
                };
              }
            }
          });
        } else if (isActive && autoRotate && slides.length > 1 && !autoRotateInterval) {
          autoRotateInterval = setInterval(loop, delay);
        }
      });

      bullets.forEach((bullet, i) => {
        bullet.classList.toggle('active', i === index);
      });
    }

    function loop() {
      if (videoPlaying) return;
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }

    function handleBulletClick(e, index) {
      e.preventDefault();
      currentIndex = index;
      showSlide(currentIndex);
    }

    // Shopify events
    document.addEventListener("shopify:block:select", function (event) {
      selectedBlockId = event.detail.blockId;
      clearInterval(autoRotateInterval);
      autoRotateInterval = null;
      pauseAutoRotate = false;
      autoRotate = false;

      const selectedSlide = container.querySelector(`[data-block-id="${selectedBlockId}"]`);
      if (selectedSlide) {
        const index = Array.from(slides).findIndex(
          (s) => s.getAttribute("data-block-id") === selectedBlockId
        );
        if (index !== -1) {
          currentIndex = index;
          showSlide(currentIndex);
        }

        const videos = selectedSlide.querySelectorAll("video");
        videos.forEach((video) => {
          video.loop = true;
          video.play().catch(console.warn);
        });
      }
    });

    document.addEventListener("shopify:block:deselect", initSlideshow);
    document.addEventListener("shopify:section:select", initSlideshow);
    document.addEventListener("shopify:section:deselect", () => {
      initSlideshow();
      showSlide(0);
    });

    initSlideshow();
  }
});
window.addEventListener("load", function() {
  const slideshows = document.querySelectorAll('[id^="atomic-slideshow-"]');

  slideshows.forEach(container => {
    const slider = container.querySelector('.slider');
    if (!slider) return;

    // Find all slides with data-block-id
    const slides = slider.querySelectorAll('.slide[data-block-id]');
    if (slides.length > 0) {
      // Ensure one slide has "active" class
      const activeSlide = slider.querySelector('.slide.active');
      if (!activeSlide) {
        slides[0].classList.add('active');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
